import { observer } from 'mobx-react'
import React, { Component } from 'react'
import Select from 'react-select'

import Input from '../../../form/Input'
import MagicQuadrantStore from './MagicQuadrantStore'
import Panel from '../../../../UniformComponents/Panel'
import Button from '../../../../UniformComponents/Button'

import './magicQuadrant.scss'

@observer
class MagicQuadrant extends Component {
    constructor(props) {
        super(props)
        const { store } = props
        this.magicQuadrantStore = new MagicQuadrantStore(store)
    }

    componentDidMount() {
        const { store } = this.props
        this.magicQuadrantStore.getClients()
        store.breadcrumps = [
            {
                name: 'intranet',
                url: '/intranet',
                title: 'Intranet',
            },
            {
                name: 'magicquadrant',
                url: '/intranet/magicquadrant',
                title: 'Magic Quadrant Import',
            },
        ]
    }

    renderFilters = () => {
        const { clientOptions, handleChange, submitMagicQuadrant } = this.magicQuadrantStore
        return (
            <div className="filterPanel">
                <div>
                    <h2>
                        Expected file structure for comma-separated CSV
                        eventName, productId, year, dataColumn1, dataColumn2,...
                    </h2>
                </div>
                <div>
                    <Select
                        options={clientOptions}
                        onChange={(e) => handleChange(e, 'client')}
                    />
                </div>

                <br />

                <div>
                    <Input type="file" onChange={(e) => handleChange(e, 'file')} name="csvFile" />
                </div>

                <br />

                <Button
                    label="Submit"
                    cssClass="regular primary"
                    onClick={() => submitMagicQuadrant()}
                />
            </div>
        )
    }

    render() {
        return (
            <Panel id="magicQuadrant">
                {this.renderFilters()}
            </Panel>
        )
    }
}
export default MagicQuadrant
